<template>
  <div>
    <h2>Aktuelle Meldungen</h2>
    <div v-if="news.length" class="newsWrapper">
      <div v-for="item, index in news" :key="item.id" class="newsCard">
        <div class="title">{{ item.title }}</div>
        <div class="development">{{ item.created.fromNow() }}</div>
        <div class="divider" style="margin-bottom:1rem"></div>
        <div class="description" v-html="item.description.replace(/(?:\r\n|\r|\n)/g, '<br />')"></div>
      </div>
    </div>
    <div class="loaderWrapper" v-else>
      <div>
        <i class="fa fa-spin fa-spinner"></i> News werden geladen ...
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import de from "moment/locale/de";
moment.locale("de");

export default {
  props: ["apiUrl"],
  data() {
    return {};
  },
  asyncComputed: {
    news: {
      get() {
        return this.$http.post(this.apiUrl).then(response => {
          return response.body.data.map(item =>
            Object.assign(
              {
                created: moment(item.created_on)
              },
              item
            )
          );
        });
      },
      default: []
    }
  }
};
</script>
